<div class="external-pinsheet-page" [ngClass]="{'external-pinsheet-page-desktop': isDesktop}">
    <div class="header-container">
        <div class="logo">
            <img src="../../../assets/images/new-header-logo.svg">
        </div>
        <div *ngIf="isDesktop" class="desktop-header-options">
            <h3  (click)="onClickCalendar()" class="header-items">CALENDAR</h3>
            <h3  (click)="onClickManageGreens()" class="header-items">MANAGE GREENS</h3>
            <h3 (click)="gotoLoginPage()" class="header-items">MANAGE PINS</h3>
            <!-- <h3  (click)="onClickFormat()" class="header-items">FORMAT</h3> -->
            <h3  (click)="onClickPrint()" [ngClass]="{'header-items':summaryData.HasPinsheet, 'disable-header-tems':!summaryData.HasPinsheet }">PRINT</h3>
        </div>
        <div *ngIf="!isDesktop" class="mobile-header-options">
            <!-- <h3  (click)="onClickCalendar()" class="header-items">CALENDAR</h3>
            <h3  (click)="onClickManageGreens()" class="header-items">MANAGE<br>GREENS</h3>
            <h3 (click)="gotoLoginPage()" class="header-items">MANAGE<br>PINS</h3> -->
            <!-- <h3  (click)="onClickFormat()" class="header-items">FORMAT</h3> -->
            <h3 (click)="onClickPrint()" [ngClass]="{'header-items':summaryData.HasPinsheet, 'disable-header-tems':!summaryData.HasPinsheet }">PRINT</h3>
            <div *ngIf="!isDesktop" [ngClass]="{'hamburger-menu-no-click': !allowHamburgerClick,
                'hamburger-menu': allowHamburgerClick }" (click)="openMiniGrid()">
                <div class="menu-icon"></div>
                <div class="menu-icon"></div>
                <div class="menu-icon"></div>
            </div>
        </div>
    </div>
    <div class="alignOneByOne">
        <div class="toggleButtonContainer" *ngIf="!isDesktop">
            <h4 style="margin: 0px;">SHOW FRONT & SIDE LINES</h4>
            <app-toggleswitch class="toggleText"  [checked]="showFrontSideLines" (click)="toogleFrontSideLines()"></app-toggleswitch>
        </div>
        <div class="course-dropdown-container " [ngStyle]="{width: (isMultipleCourseClient || has27Green || has36Green) ? '100%' : 'auto' }">
            <app-dropdown  *ngIf="isMultipleCourseClient || isUngroupedCoursePresent() || (!isDesktop && (has27Green || has36Green))"
                [label]="courseLabel"
                [Isshow]="!(has27Green || has36Green || isMultipleCourseClient )"  (setSelected)="setCourseSelectedValue($event)"
                (selectedId)="onCourseSelection($event)" [dropdownArr]="courseList"
                [page]="'ext-pinsheet'" [manage]="true" [isFont]="!isDesktop">
            </app-dropdown>
            <p *ngIf="!(isMultipleCourseClient || has27Green || has36Green) && isDesktop" class="pinsheet_title">{{courseLabel}}</p>
            <h2 *ngIf="!(isMultipleCourseClient || has27Green || has36Green) && !isDesktop" class="pinsheet_title">{{courseLabel}}</h2>
        </div>
        <div *ngIf="isDesktop" class="desktop-toggleButtonContainer">
            <h4 style="margin: 0px;">SHOW FRONT & SIDE LINES</h4>
            <app-toggleswitch class="toggleText"  [checked]="showFrontSideLines" (click)="toogleFrontSideLines()"></app-toggleswitch>
        </div>
        
    </div>

    <div class="external-pinsheet-container" [ngClass]="{'external-pinsheet-container-desktop': isDesktop}" #externalPinsheet
        (touchstart)="swipe($event, 'start')" (touchend)="swipe($event, 'end')">
        <ngx-ui-loader class="ext-pinsheet-loader" [fgsColor]="'#01395d'"
            [bgsColor]="'#01395d'" [overlayColor]="'rgba(40,40,40,0.5)'" [hasProgressBar]="false">
        </ngx-ui-loader>
        <app-pinsheet-grid *ngIf="isDesktop"
            [page]="'externalPinsheet'" [summaryData]="summaryData" [has27Green]="has27Green"
            [has36Green]="has36Green" [isMultiplePinsheetCourse]="isMultiplePinsheetCourse"
            [cols]="cols" [rowHeight]="rowHeight" [primaryGreens]="primaryGreens"
            [secondaryGreens]="secondaryGreens" [courseList]="courseList"
            [has27Course1]="has27Course1" [has27Course2]="has27Course2" [has27Course3]="has27Course3"
            [has36Course1]="has36Course1" [has36Course2]="has36Course2" [has36Course3]="has36Course3" 
            [has36Course4]="has36Course4" [showMessage]="hasSummaryResponse" [externalAccessKey]="externalAccesskey"
            [isGroupedCourse]="isGroupedCourse()">
        </app-pinsheet-grid>
        <div *ngIf="!isDesktop" class="pinsheet-green-container">
            <div *ngIf="hasSummaryResponse && !summaryData.HasPinsheet" class="message-container">
                <p class="hidepinsheet">No Pinsheet Generated for this day</p>
            </div>
            <div *ngIf="summaryData.HasPinsheet" class="green-display-container">
                <img class="green-switch-arrows left-arrow" src="../../assets/images/tag.svg " 
                    [ngClass]="{'disable-click': selectedGreen.Id == summaryData.GreenList[0].Id}"
                    (click)="changeSelectedGreen(true)"/>
                <div class="green" [attr.data-greenname]="selectedGreen.Id">
                    <div class="green-top">
                        <div class="green-name">
                            <h2>Hole {{selectedGreen.Name}}
                            </h2>
                        </div>
                        <div class="green-depth">
                            <h2>Depth: {{selectedGreen.Depth}}
                            </h2>
                        </div>
                    </div>
                    <div class="green-img" [routerLink]="['/external/pinsheetdetails',courseList[0].CourseID,selectedGreen.PinsheetID,selectedGreen.Id]"
                    [queryParams]="{accessKey: externalAccesskey}">
                        <img src="{{'data:image/jpg;base64,'+selectedGreen.Image}}" class="green_image eighteen_green">
                    </div>
                    <div class="green-bottom">
                        <div class="green-hole-center">
                            <h2>{{selectedGreen.Center || 'X'}}
                            </h2>
                        </div>
                        <div class="green-position">
                            <h2 *ngIf="selectedGreen.Position != null ||  selectedGreen.Position !=''">{{selectedGreen.Position}}</h2>
                            <h2 *ngIf="selectedGreen.Position == null ||  selectedGreen.Position ==''" style="color:rgb(192,0,0);">
                                {{'Select Hole'}}</h2>
                        </div>
                    </div>
                </div>
                <img class="green-switch-arrows" src="../../assets/images/tag.svg " 
                    [ngClass]="{'disable-click': selectedGreen.Id == summaryData.GreenList[summaryData.GreenList.length-1].Id}"
                    (click)="changeSelectedGreen()"/>
            </div>
        </div>
    </div>
</div>
<ng-template #messageDialog>
    <h3 mat-dialog-title class="pop-up-message">{{popupMessage}}</h3>
    <div mat-dialog-actions>
        <button class="btn pop-up-button" mat-dialog-close (click)="onPopupClose()">OK</button>
    </div>
</ng-template>
<ng-template #miniGridDialog>
    <div>
        <button class="grid-close" mat-button (click)="onPopupClose()">X</button>
        <div class="grid-container" [ngClass]="{'nine-green-grid': (has27Green && isGroupedCourse()) || (has36Green && isGroupedCourse())}">
            <div class="grid-item" *ngFor="let green of summaryData.GreenList"
            [ngClass]="{'selected': selectedGreenId == green.Id}" 
            (click)="onGreenSelection(green.Id); onPopupClose()">
                {{green.Name}}
            </div>
        </div>
    </div>
</ng-template>
<ng-template #holeLocationMissingGreensRef style="position: relative;">
        <div *ngFor="let course of missedHoleGreenGroup; let lastCourse = last" >
            <h3 *ngIf="courseList.length > 1" mat-dialog-title class="pop-up-text" style="font-weight: bold;text-align: left">{{course.courseName}} </h3>
            <h4 mat-dialog-title class="pop-up-text" style="text-align: left">Green{{course.greens.length > 1 ? 's':''}}
                <span *ngFor="let green of course.greens; let last = last">
                    {{ green.Name }}<span *ngIf="!last">, </span>
                </span>
                {{course.greens.length > 1 ? "are": "is"}} missing the hole location
            </h4>
            <hr *ngIf="missedHoleGreenGroup && !lastCourse" style="margin: 0px; padding: 0px;">
        </div>
        <div mat-dialog-actions>
            <button class="btn pop-up-button theme-button" mat-dialog-close>Close</button>
            <button class="btn pop-up-button theme-button" (click)="printAnyways()">Print Anyways</button>
        </div>
    </ng-template>
    <ng-template #holeLocationMessageWarningRef>
        <app-no-hole-message [data]="noHoleLocationsData" (closeWarningPopup)="closeWarning()">
        </app-no-hole-message>
    </ng-template>